<template>
  <div>
    <ContentHeader title="Detail Disbursement" />
    <section class="content">
      <div class="container card p-2 p-md-4">
        <h4>Name Recipient</h4>
        <h6>{{disbursement.recipient.name}}</h6>
        <h5>Recipient Type</h5>
        <p v-if="disbursement.recipient.type === 'CORPORATE_PARTNER'">Manager Cabang</p>
        <p v-else-if="disbursement.recipient.type === 'MASTER_IB'">Manager Area</p>
        <p v-else-if="disbursement.recipient.type === 'PARTNER_IB'">Supervisor Area</p>
        <p v-else-if="disbursement.recipient.type === 'INTRODUCING_BROKER'">Agent</p>
        <h5>Status</h5>
        <p class="btn btn-warning rounded-pill w-status" v-if="disbursement.status == 'PENDING'">{{disbursement.status}}</p>
        <p class="btn btn-success rounded-pill w-status" v-else-if="disbursement.status == 'INSTALLED'">{{disbursement.status}}</p>
        <p class="btn btn-success rounded-pill w-status" v-else-if="disbursement.status == 'SUCCESS'">{{disbursement.status}}</p>
        <p class="btn btn-danger rounded-pill w-status" v-else-if="disbursement.status == 'EXPIRED'">{{disbursement.status}}</p>
        <h5>Amount</h5>
        <p> Rp {{new Intl.NumberFormat('id-ID').format(Number(disbursement.amount).toFixed())}}</p>
        <div class="row">
            <div class="col-md-6">
                <h5>Transaction Code</h5>
                <p>{{disbursement.transaction.transaction_code}}</p>
            </div>
            <div class="col-md-6">
                <h5>Product Type</h5>
                <p>{{disbursement.transaction.product_type}}</p>
            </div>
            <div class="col-md-6">
                <h5>Investor Name</h5>
                <p>{{disbursement.transaction.investor.name}}</p>
            </div>
            <div class="col-md-6">
                <h5>Transaction type</h5>
                <p v-if="disbursement.transaction.transaction_type == 'INITIAL_LICENSE'">Initial License</p>
                <p v-else-if="disbursement.transaction.transaction_type != 'INITIAL_LICENSE'">{{disbursement.transaction.transaction_type}}</p>
            </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiClient from '../services/ApiServices';
// import apiClient from '../services/ApiServices';

export default {
  components: {
    ContentHeader
  },
  data() {
    return {
     disbursement:[]
    };
  },
  async mounted() {
    try {
      let response = await apiClient.get(`${this.$user_id}/disbursement/${this.$route.params.id}/`)
      this.disbursement = response.data.data 
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    } finally {
      this.loading = false
    }
  },
};
</script>
<style scoped>
.content h5, .content h4{
    font-weight: 600;
}
.w-status{
    width: 110px;
}
.content-wrapper{
  min-height: 400px !important;
}
.card-footer{
  padding: 0.3rem 1.25rem !important;
}
</style>
